import React from 'react'
import type { SVGProps } from 'react'
const SvgGlyphSmallCancel = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
        <path d="m63.79 63.2-3.88 3.88-9.71-9.7-9.7 9.7-3.88-3.88 9.7-9.71-9.7-9.7 3.88-3.88 9.7 9.7 9.71-9.7 3.88 3.88-9.7 9.7z" />
    </svg>
)
export default SvgGlyphSmallCancel
